export class NegativeIndexOutOfBoundsError extends Error {
    name = "NegativeIndexOutOfBoundsError";
    static build(array, index) {
        return new NegativeIndexOutOfBoundsError(`Negative index "${index}" points to unassignable index "${array.length + index}" in array with length ${array.length}.`);
    }
}
